import { axios } from '@/utils/request'

const api = {
  getChartImage: '/image'
}

export default api

export function getChartImage (item) {
  return axios({
    url: api.getChartImage,
    method: 'get',
    params: { id: item }
  })
}
